import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload, Switch } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import CounterCreationSchema from "../../../../Schemas/CounterCreationSchema";

import {
  createCounter,
  updateCounter,
} from "../../../../Services/CounterService";
import { useHistory } from "react-router-dom"; // useHistory for v5

function CounterCreationForm({
  data = {},
  DeptData,
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code || "",
      dept: data.dept || "",
      isActive: data.isActive !== undefined ? data.isActive : true,
    },
    enableReinitialize: true,
    validationSchema: CounterCreationSchema,
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  const handleSubmit = async () => {
    const values = formik.values;
    if (isEmpty(values.name) || isEmpty(values.code)) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createCounter(values);
        message.success("Counter created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the counter list or wherever you want
      } else {
        const updatedCounter = await updateCounter(data._id, values);
        callReFetch();
        message.success(
          updatedCounter?.data?.message || "Counter updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const { values } = formik;
  const titleText = isEditMode ? "Counter Detail" : "Create Counter";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter counter name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Department Store" required>
            <Select
              style={{ width: "100%" }}
              placeholder="Select a Department Store"
              onChange={(value) => formik.setFieldValue("dept", value)}
              value={values.dept}
            >
              {DeptData.map((dept) => (
                <Select.Option key={dept.name} value={dept.name}>
                  {dept.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              name="code"
              placeholder="Enter brand code"
              onChange={(e) => {
                const value = e.target.value;
                formik.setFieldValue("code", value); // Set only if between 0-100
              }}
              value={formik.values.code}
            />
          </Form.Item>
          <Form.Item label="Active Status">
            <Switch
              checked={values.isActive}
              onChange={(checked) => formik.setFieldValue("isActive", checked)}
              checkedChildren="Active"
              unCheckedChildren="Inactive"
            />
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

CounterCreationForm.propTypes = {};

export default CounterCreationForm;
